export enum LocalStorageKey {
  tokens = 'tokens',
  locale = 'locale',
}

export interface Tokens {
  accessToken: string
  refreshToken: string
}
